(function($) {

	$.fn.modal = function() {
		var elem = $(this),
			closeBtn = elem.find('.js-modal__close'),
			showTrigger = $('.js-modal__show'),
			settings = {
				autoShow: false,
				autoShowTimeout: 100,
				destroyTimeout: 800,
				activeClass: 'is-active',
				destroyOnClose: false
			};

		var init = function() {

            // Parse settings
            settings = $.extend(true, {}, settings, elem.parseSettings());

            // If the modal is to be shown immediately then show it on timeout
            if(settings.autoShow) {
            	setTimeout(function() {
					toggle('show');
            	}, settings.autoShowTimeout);
            }

			// Show when show trigger clicked
			showTrigger.on('click', function(evt) {
				evt.preventDefault();
				toggle('hide');
			});

			// Hide when close trigger clicked
			closeBtn.on('click', function(evt) {
				evt.preventDefault();
				toggle('hide');
			});

			// Hide when escape key pressed
			$.esc({
				callback: function(evt) {
					toggle('hide');
				}
			});
		},

		toggle = function(command) {

			switch(command) {
				case 'hide':
				default:
					elem.removeClass(settings.activeClass);
          elem.trigger('modal.hidden');
					// Clean up if it's to be destroyed
					if(settings.destroyOnClose) {

						setTimeout(function() {
							elem.parent().html("");
							elem = null;
						}, settings.destroyTimeout);

					}

					break;
				case 'show':
					elem.addClass(settings.activeClass);
					break;
			}
		};

		init();
		return this;
	};

}($));
